import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Club } from "../../../../interfaces/club";
import { Athlete, AthleteTeamSeason } from "../../../../interfaces/athlete";
import { getAthlete } from "../../../../services/athlete";
/*import { AdminAthleteNew } from "./athlete-new";*/
import { ManagementAthleteEdit } from "./athlete-edit";
/*import { AdminAthleteDelete } from "./athlete-delete";*/
import moment from 'moment';
import { getClubOptions } from "../../../../services/club";
import avatar from "../../../../assets/images/avatar.svg";
import { ManagementAthleteMeasurement } from "./athlete-measurement";
import { AdminAthleteNew } from "../../admin/athletes/athlete-new";
import { Link } from "react-router-dom";
import { CoachAthletePerformance } from "../../coach/athletes/athlete-performance";

export function ManagementAthleteList() {
    const [athletes, setAthletes] = useState<Athlete[]>([]);
    const [clubOptions, setClubOptions] = useState<any[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    /*onst [showDelete, setShowDelete] = useState(false);*/
    const [showEdit, setShowEdit] = useState(false);
    const [showMeasurement, setShowMeasurement] = useState(false);
    const [showPerformance, setShowPerformance] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [searchParams, setSearchParams] = useState({
        search: '',
        club: '',
        sortbyfield: 'updated_at',
        sortbytype: 'DESC'
    });

    useEffect(() => {
        getClubOptions()
            .then(response => {
                setClubOptions(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        getAthlete('', '', '', '', 'updated_at', 'DESC', 1, 12)
            .then(response => {
                const athletesData = response.data;
                setAthletes(athletesData);
                setHasMore(athletesData.length === 12);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club.value;
        const sortbyfield = event.target.sortbyfield.value;
        const sortbytype = event.target.sortbytype.value;

        setSearchParams({ search: s, club, sortbyfield, sortbytype });
        setCurrentPage(1);

        getAthlete(s, club, '', '', sortbyfield, sortbytype, 1, 12)
            .then(response => {
                const athletesData = response.data;
                setAthletes(athletesData);
                setHasMore(athletesData.length === 12);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleLoadMore = (event: any) => {
        event.preventDefault();
        const nextPage = currentPage + 1;

        getAthlete(
            searchParams.search,
            searchParams.club,
            '',
            '',
            searchParams.sortbyfield,
            searchParams.sortbytype,
            nextPage,
            12
        )
            .then(response => {
                const newAthletes = response.data;
                setAthletes([...athletes, ...newAthletes]);
                setCurrentPage(nextPage);
                setHasMore(newAthletes.length === 12);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: Athlete) => {
        const newAthletes = [
            s,
            ...athletes
        ];
        setAthletes(newAthletes);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    /*const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }*/

    /*const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newAthletes = athletes.filter((m: Athlete) => m.id != id);
        setAthletes(newAthletes);
        setShowDelete(false);
    }*/

    /*const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }*/

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedAthlete: Athlete) => {
        setSelectedId(0);
        const newAthletes = athletes.map((m: Athlete) => {
            if (m.id == changedAthlete.id) {
                return changedAthlete;
            } else {
                return m;
            }
        });
        setAthletes(newAthletes);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handleMeasurement = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowMeasurement(true);
    }

    const handleMeasurementOnSave = (changedAthlete: Athlete) => {
        setSelectedId(0);
        /*const newAthletes = athletes.map((m: Athlete) => {
            if (m.id == changedAthlete.id) {
                return changedAthlete;
            } else {
                return m;
            }
        });
        setAthletes(newAthletes);*/
        setShowMeasurement(false);
    }

    const handleMeasurementOnClose = () => {
        setSelectedId(0);
        setShowMeasurement(false);
    }

    const handlePerformance = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowPerformance(true);
    }

    const handlePerformanceOnSave = (changedAthlete: Athlete) => {
        setSelectedId(0);
        setShowPerformance(false);
    }

    const handlePerformanceOnClose = () => {
        setSelectedId(0);
        setShowPerformance(false);
    }

    return (
        <div className="athletes-list-container">
            <h1>
                { t('athletes')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="text" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="club_id">
                        <Form.Select aria-label={ t("club") } name="club">
                            <option value="">{ t("select_club") }</option>
                            { clubOptions.map((c: Club) => {
                                return <option key={ 'club-' + c.id } value={ c.id }>{ c.name }</option>;
                            })}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="sortbyfield">
                        <Form.Select aria-label={ t("Sort by") } name="sortbyfield" defaultValue={ 'updated_at' }>
                            <option value="updated_at">{ t("Sort by updated") }</option>
                            <option value="name">{ t("Sort by name") }</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="sortbytype">
                        <Form.Select aria-label={ t("Sort type") } name="sortbytype" defaultValue={ 'DESC' }>
                            <option value="ASC">{ t("Ascending") }</option>
                            <option value="DESC">{ t("Descending") }</option>
                        </Form.Select>
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="grid-container">
                <Row>
                    { athletes.map((a: Athlete) => {
                        return <Col key={ 'athlete-' + a.id } xs={12} md={6} lg={4}>
                            <div className="athlete-card">
                                <div className="heading">
                                    <div className="avatar">
                                        { a.avatar.length > 0 &&
                                            <img src={ a.avatar[0].url } alt={ a.name } />
                                        }
                                        { a.avatar.length == 0 &&
                                            <img src={ avatar } alt={ a.name } />
                                        }
                                    </div>
                                    <div className="meta">
                                        <div className="name">
                                            <Link to={ '/athletes/' + a.id + '/view' } title={ a.name } target="_blank">{ a.name }</Link>
                                        </div>
                                        <div className="years">
                                            { moment(new Date()).diff(a.birthdate, 'years') + ' ' + t("years").toLowerCase() }
                                        </div>
                                        <div className="team">
                                            {
                                               a.registered_in.map((ats: AthleteTeamSeason) => {
                                                    return ats.club_name + '/' + ats.team_name;
                                                }).join(', ')
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="actions">
                                    <a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ a.id }>
                                        <i className="bi bi-pencil-square"></i>
                                    </a>
                                    <a href="#" className="icon-link measurement" title={ t("Measurements") } onClick={ handleMeasurement } data-id={ a.id }>
                                        <i className="bi bi-clipboard-data"></i>
                                    </a>
                                    <a href="#" className="icon-link performance" title={ t("Performance") } onClick={ handlePerformance } data-id={ a.id }>
                                        <i className="bi bi-bar-chart-steps"></i>
                                    </a>
                                    {/*<a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ a.id }>
                                        <i className="bi bi-trash"></i>
                                    </a>*/}
                                </div>
                            </div>
                        </Col>
                    })}
                </Row>
                { hasMore &&
                    <div className="load-more-container" style={{ textAlign: 'center', marginTop: '20px' }}>
                        <Button variant="primary" onClick={ handleLoadMore }>
                            { t("Load more") }
                        </Button>
                    </div>
                }
            </div>   
            {/*<a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>*/}
            {/* showAddNew &&
                <AdminAthleteNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            */}
            { showEdit && (selectedId != 0) &&
                <ManagementAthleteEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showMeasurement && (selectedId != 0) &&
                <ManagementAthleteMeasurement id={ selectedId } onSave={ handleMeasurementOnSave } onClose={ handleMeasurementOnClose } />
            }
            { showPerformance && (selectedId != 0) &&
                <CoachAthletePerformance id={ selectedId } onSave={ handlePerformanceOnSave } onClose={ handlePerformanceOnClose } />
            }
            {/* showDelete && (selectedId != 0) &&
                <AdminAthleteDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            */}
        </div>

    )
}
